import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import { ArrowLeft, ArrowRight } from "../Arrow";
import { ZoomLens } from "../ZoomLens";
import { Container } from "../Container";
import "./image-slide-show.css";

const ImageSlideShow = ({ 
    slides, 
    hasSliderSyncing = false, 
    isFluid = false, 
    colorSelect = '#fff' ,
    mediaCaption='',
    mediaCaptionPosition='',
    mediaCaptionColor='#000'
}) => {
    const colorSelected = colorSelect === null ? '#fff' : colorSelect;
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    let sliderRef1 = useRef(null);
    let sliderRef2 = useRef(null);

    const PrevArrow = (props) => {
        const { onClick } = props;
        return (
            <div className="prev" onClick={onClick}>
                <ArrowLeft isColored={true} />
            </div>
        );
    };

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <div className="next" onClick={onClick}>
                <ArrowRight isColored={true} />
            </div>
        );
    };

    useEffect(() => {
        setNav1(sliderRef1.current);
        setNav2(sliderRef2.current);
    }, []);

    function isColorDark(color) {
        let r, g, b;
        if (color.length === 4) {
            r = parseInt(color[1] + color[1], 16);
            g = parseInt(color[2] + color[2], 16);
            b = parseInt(color[3] + color[3], 16);
        } else {
            r = parseInt(color.substr(1, 2), 16);
            g = parseInt(color.substr(3, 2), 16);
            b = parseInt(color.substr(5, 2), 16);
        }
    
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
        return luminance < 0.5;
    }

    const images = [
        'https://images.ctfassets.net/tg5mrahr7vmv/wf5NYsFbmEwNi1qMbmEmk/2eed869794b363cb4f30eb4b4a536363/tri-seal.jpg',
        'https://images.ctfassets.net/tg5mrahr7vmv/3c3yNjyNrwCrrrBsCL0MBs/f5365e814cdb078e5f62eca84c7f7d01/Web_Compost__illustration.jpg',
        'https://images.ctfassets.net/tg5mrahr7vmv/wf5NYsFbmEwNi1qMbmEmk/2eed869794b363cb4f30eb4b4a536363/tri-seal.jpg',
        'https://images.ctfassets.net/tg5mrahr7vmv/3c3yNjyNrwCrrrBsCL0MBs/f5365e814cdb078e5f62eca84c7f7d01/Web_Compost__illustration.jpg'
    ]

    const [currentIndex, setCurrentIndex] = useState(0)

    // Function to change slides on dot click
    const goToSlide = (index) => {
        setCurrentIndex(index)
    }

    return (
        <div className="thumbnail-nav-slider">
            <div className="slider-wrapper" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                {/* {images.map((image, index) => (
                    <div key={index} className="slider-slide">
                        <img src={image} alt={`Slide ${index + 1}`} />
                    </div>
                ))} */}
                {slides.map((sliderItem, sliderIndex) => {     
                    return (
                        <div key={sliderIndex} className="relative slider-slide" style={{ backgroundColor: colorSelected }}>
                            <div className="relative p-10 slider-item__inner">
                                {sliderItem.gatsbyImageData && sliderItem.gatsbyImageData.images && sliderItem.gatsbyImageData.images.fallback ? (
                                    <ZoomLens imgUrl={sliderItem.gatsbyImageData.images.fallback.src} />
                                ): <ZoomLens imgUrl={sliderItem.gatsbyImageData.images.sources.srcSet} />}
                            </div>
                            {mediaCaption && (
                                <p className={`absolute bottom-0 left-0 my-0 px-15 pb-15 text-${mediaCaptionPosition}`} style={{ backgroundColor: colorSelected }}>
                                    <span className='bold' style={{ color: mediaCaptionColor }}>{mediaCaption}</span>
                                </p>
                            )}
                        </div>
                    )
                })}
            </div>
            <div className="w-full border-top-black-45 dots" style={{ backgroundColor: colorSelected }}>
                {slides.map((sliderItem, sliderIndex) => (
                    <div key={sliderIndex} className={`relative bg-cover bg-norepeat bg-center slider-item dot${currentIndex === sliderIndex ? " active" : ""}`} onClick={() => goToSlide(sliderIndex)} style={{ backgroundImage: `url(${sliderItem.gatsbyImageData.images.fallback.src || 'https://images.ctfassets.net/tg5mrahr7vmv/3c3yNjyNrwCrrrBsCL0MBs/f5365e814cdb078e5f62eca84c7f7d01/Web_Compost__illustration.jpg'})`, height: '88px', width: '108px' }}>
                    </div>
                ))}
            </div>
        </div>
        // <div className="component-slideshow">
        //     <div className="w-large">
        //         <Slider
        //             asNavFor={nav2}
        //             ref={sliderRef1}
        //             className="slider-main"
        //             prevArrow={<PrevArrow />}
        //             nextArrow={<NextArrow />}
        //             fade={true}
        //         >
        //             {slides.map((sliderItem, sliderIndex) => {
                        
        //                 return (
        //                     <div key={sliderIndex} className="slider-item">
        //                         <div className="relative slider-item__inner" style={{ backgroundColor: colorSelected }}>
        //                             {sliderItem.gatsbyImageData && sliderItem.gatsbyImageData.images && sliderItem.gatsbyImageData.images.fallback ? (
        //                                 <ZoomLens imgUrl={sliderItem.gatsbyImageData.images.fallback.src} />
        //                             ): <ZoomLens imgUrl={sliderItem.gatsbyImageData.images.sources.srcSet} />}
        //                         </div>
        //                         {mediaCaption && (
        //                             <p style={{ backgroundColor: colorSelected }} className={`my-0 px-15 pb-15 text-${mediaCaptionPosition}`}>
        //                                 <span className='bold' style={{ color: mediaCaptionColor }}>{mediaCaption}</span>
        //                             </p>
        //                         )}
        //                     </div>
        //                 )
        //             })}
        //         </Slider>
        //         {(slides.length > 1) && (
        //             <Slider
        //                 asNavFor={nav1}
        //                 ref={sliderRef2}
        //                 slidesToShow={2}
        //                 swipeToSlide={true}
        //                 focusOnSelect={true}
        //                 className="slider-nav"
        //             >
        //                 {slides.map((sliderItem, sliderIndex) => (
        //                     <div key={sliderIndex} className="relative slider-item">
        //                         <div className="slider-item__inner" style={{ backgroundColor: colorSelected }}>
        //                             {sliderItem && sliderItem.gatsbyImageData && sliderItem.gatsbyImageData.images && sliderItem.gatsbyImageData.images.fallback ? (
        //                                 <img src={sliderItem.gatsbyImageData.images.fallback.src} alt={`Slide ${sliderIndex}` || 'Carousel Media'} />
        //                             ) : <img src={sliderItem.gatsbyImageData.images.sources.srcSet} alt={`Slide ${sliderIndex}` || 'Carousel Media'} />}
        //                         </div>
        //                     </div>
        //                 ))}
        //             </Slider>
        //         )}
        //     </div>
        // </div>
    );
};

export default ImageSlideShow;
